//CUISINE list
export const CUISINE_LIST_REQUEST = 'CUISINE_LIST_REQUEST';
export const CUISINE_LIST_SUCCESS = 'CUISINE_LIST_SUCCESS';
export const CUISINE_LIST_FAIL = 'CUISINE_LIST_FAIL';
